import { render, staticRenderFns } from "./PromotionDisplayingCart.vue?vue&type=template&id=6e0ee20c&scoped=true&"
import script from "./PromotionDisplayingCart.vue?vue&type=script&lang=js&"
export * from "./PromotionDisplayingCart.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDisplayingCart.vue?vue&type=style&index=0&id=6e0ee20c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0ee20c",
  null
  
)

export default component.exports